document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initComparador();
  initGaleria();
  initVariantes();
  initCantidad();
  initFaq();
  initPasosEscena();
  initTiltCards();
  initParallaxHero();
});

var mtPrefiereMenosMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  var wraps = document.querySelectorAll('.mt-comparador__wrap');
  wraps.forEach(function (wrap) {
    var antes = wrap.querySelector('.mt-comparador__antes');
    var linea = wrap.querySelector('.mt-comparador__linea');
    if (!antes || !linea) return;
    var arrastrando = false;

    function mover(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      linea.style.left = pct + '%';
    }
    wrap.addEventListener('mousedown', function () { arrastrando = true; });
    window.addEventListener('mouseup', function () { arrastrando = false; });
    wrap.addEventListener('mousemove', function (e) {
      if (arrastrando) mover(e.clientX);
    });
    wrap.addEventListener('mouseleave', function () { arrastrando = false; });
    wrap.addEventListener('touchmove', function (e) {
      if (e.touches[0]) mover(e.touches[0].clientX);
    }, { passive: true });
    wrap.addEventListener('click', function (e) {
      mover(e.clientX);
    });
  });
}

function initGaleria() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('.mt-galeria__principal img');
    var minis = galeria.querySelectorAll('.mt-galeria__mini');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (src) principal.src = src;
        minis.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
      });
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('#mt-producto-form');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioActual = form.querySelector('[data-mt-precio-actual]');
    var precioAnterior = form.querySelector('[data-mt-precio-anterior]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');

    function opcionesSeleccionadas() {
      var vals = [];
      selects.forEach(function (group) {
        var activo = group.querySelector('.mt-activa');
        vals.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return vals;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioActual) precioActual.textContent = formatearDinero(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = formatearDinero(variante.compare_at_price);
          precioAnterior.hidden = false;
        } else {
          precioAnterior.hidden = true;
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available
          ? botonComprar.getAttribute('data-texto-disponible')
          : botonComprar.getAttribute('data-texto-agotado');
      }
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
      });
    }

    form.querySelectorAll('.mt-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grupo = btn.closest('[data-mt-opcion]');
        grupo.querySelectorAll('.mt-swatch').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
        actualizar();
      });
    });

    actualizar();
  });
}

function initCantidad() {
  document.querySelectorAll('.mt-cantidad').forEach(function (cant) {
    var input = cant.querySelector('input');
    var menos = cant.querySelector('[data-mt-menos]');
    var mas = cant.querySelector('[data-mt-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}

function initPasosEscena() {
  document.querySelectorAll('[data-mt-pasos-escena]').forEach(function (escena) {
    var pasos = escena.querySelectorAll('[data-mt-paso]');
    var imagenes = escena.querySelectorAll('[data-mt-paso-imagen]');
    if (!pasos.length || !imagenes.length) return;

    function activar(indice) {
      pasos.forEach(function (p) { p.classList.toggle('mt-activa', p.getAttribute('data-mt-paso') === String(indice)); });
      imagenes.forEach(function (im) { im.classList.toggle('mt-activa', im.getAttribute('data-mt-paso-imagen') === String(indice)); });
    }

    if (!('IntersectionObserver' in window)) { activar(0); return; }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activar(entry.target.getAttribute('data-mt-paso'));
        });
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );
    pasos.forEach(function (p) { obs.observe(p); });
  });
}

function initTiltCards() {
  if (mtPrefiereMenosMovimiento) return;
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
  document.querySelectorAll('.mt-beneficio').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'translateY(-6px) rotateX(' + (y * -8) + 'deg) rotateY(' + (x * 8) + 'deg)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}

function initParallaxHero() {
  if (mtPrefiereMenosMovimiento) return;
  var banner = document.querySelector('.mt-hero__banner');
  if (!banner) return;
  var ticking = false;
  function actualizar() {
    var desplazamiento = Math.max(0, Math.min(60, window.scrollY * 0.15));
    banner.style.transform = 'scale(1.08) translateY(' + desplazamiento + 'px)';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(actualizar);
  }, { passive: true });
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item, .mt-descripcion-rica');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      var grupo = item.closest('[data-mt-faq-grupo]');
      if (!grupo) return;
      grupo.querySelectorAll('details[open]').forEach(function (otro) {
        if (otro !== item) otro.removeAttribute('open');
      });
    });
  });
}
